import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_editor = _resolveComponent("editor")
  const _component_field = _resolveComponent("field")

  return (_openBlock(), _createBlock(_component_field, _normalizeProps(_guardReactiveProps({ ..._ctx.$attrs, ..._ctx.$props })), {
    "field-description": _withCtx(() => [
      _renderSlot(_ctx.$slots, "field-description"),
      _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1 /* CACHED */))
    ]),
    default: _withCtx(() => [
      _createVNode(_component_editor, {
        ref: "editorComponent",
        value: _ctx.model,
        "read-only": _ctx.readOnly,
        "show-toolbar": $props.showToolbar,
        "toolbar-controls": $options.resolvedToolbarControls,
        qa: $options.editorQa,
        "output-format": $props.outputFormat,
        onInput: _cache[0] || (_cache[0] = $event => (_ctx.model = $event))
      }, null, 8 /* PROPS */, ["value", "read-only", "show-toolbar", "toolbar-controls", "qa", "output-format"]),
      ($props.maxLength)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['gfu-editor-char-counter', { 'gfu-editor-char-counter--over': $options.isOverLimit }]),
            "data-qa": "editor-char-counter"
          }, _toDisplayString($options.charactersLeft) + " characters left ", 3 /* TEXT, CLASS */))
        : _createCommentVNode("v-if", true)
    ]),
    _: 3 /* FORWARDED */
  }, 16 /* FULL_PROPS */))
}